import { render, staticRenderFns } from "./TableSegregation.vue?vue&type=template&id=63aea92d&scoped=true&"
import script from "./TableSegregation.vue?vue&type=script&lang=js&"
export * from "./TableSegregation.vue?vue&type=script&lang=js&"
import style0 from "./TableSegregation.vue?vue&type=style&index=0&id=63aea92d&prod&scoped=true&lang=css&"
import style1 from "./TableSegregation.vue?vue&type=style&index=1&id=63aea92d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aea92d",
  null
  
)

export default component.exports